module.exports = __webpack_public_path__ + "assets/img/14_1084_big.af7c8e39.jpg";